import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme CSS
import "ag-grid-enterprise"
import { LicenseManager } from "ag-grid-enterprise"
import { AgGridReact } from "ag-grid-react"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useQuery } from "react-query"
import FilterAgGrid from "../Filter/FilterAgGrid"
import { Loading } from "../Loading/Loading"

LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-040678 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Administradora Mall Aventura S.A.C. )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Mall Aventura - Portal )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Mall Aventura - Portal )_need_to_be_licensed___( Mall Aventura - Portal )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released before_( 4 April 2024 )____[v2]_MTcxMjE4NTIwMDAwMA==ce13f7f5415cfa2c4d86d1e48d2e08de")

export default function AgTable({
    idContent,
    apiService,
    header,
    args,
    getData,
    conditions,
    addButton = null,
    setAuxData = null,
    titleExcel = 'Report',
    refetchInterval = false,
    rowSelection = true,
    // isRowSelectable = true,
    pagination = true,
    paginationPageSize = 10,
    rowDragManaged = true,
    animateRows = true,
    hidden = false,
    isDownload = true,
    hideFilter = false,
    fileName = 'Report',
    obligaciones,
    rowHeight = null,
    localData = null,
    updateCondition = null,
    sumColumns = false,
    suppressRowClickSelection = false,
    onSelectionChanged,
    onRowSelected,
    isRowSelectable,
    customDefaultColDef,
    rowGroupPanelShow = 'never',
    useFlex = true
}) {
    const gridRef = useRef()
    const [tableData, setTableData] = useState(null)
    const [refresh, setRefresh] = useState(true)

    // const getRows = () => [
    //     {
    //         cells: [
    //             { data: { value: titleExcel, type: 'String' }, mergeAcross: header.length - 1 },
    //         ],
    //     },
    // ];

    const getRows = useCallback(() => {
        return [
          {
            cells: [
              { data: { value: titleExcel, type: 'String' }, mergeAcross: header.length - 1 },
            ],
          },
        ];
      }, [titleExcel, header.length]);

    const onBtnExport = useCallback(() => {
        gridRef.current.api.exportDataAsExcel({ allColumns: true, prependContent: getRows(), fileName: titleExcel + ".xlsx" });
    }, [titleExcel]);

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setQuickFilter(
            document.getElementById('filter-text-box').value
        );
    }, []);

    let { data: apiResponse, isLoading } = useQuery(idContent,
        async () => {
            if (typeof apiService === 'function' && apiService !== undefined) {
                return await apiService(args)
            } else {
                return null
            }
        },
        {
            refetchInterval: refetchInterval,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            enabled: Boolean(refresh) || conditions,
        }
    )

    useEffect(() => {
        if (localData) {
            setTableData(localData);
            setRefresh(false)
            if (updateCondition) updateCondition(false)
        } else {
            if (!apiResponse) {
                setTableData([])
            }
            if (apiResponse?.data) {
                if (obligaciones) {
                    setTableData(apiResponse.data)
                    setRefresh(false)
                    if (updateCondition) updateCondition(false)
                } else {
                    setRefresh(false)
                    if (updateCondition) updateCondition(false)
                    if (!apiResponse.success) {
                        setTableData([])
                        // setFeedbackContext({ ...feedbackContext, showError: true, idError: apiResponse.errorId })
                    } else {
                        if (getData) getData(apiResponse.data)
                        setTableData((apiResponse.data.table) ? apiResponse.data.table : apiResponse.data)
                        if (apiResponse.data.auxData && setAuxData)
                            setAuxData(apiResponse.data.auxData)
                    }
                }
            } else {
                setTableData([])
            }
        }
    }, [localData, apiResponse, getData, obligaciones, setAuxData, updateCondition])

    const defaultColDef = useMemo(() => {
        const baseConfig = {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            //defaultMinWidth: 50,
            //flex: 1,
            floatingFilter: true,
            // allow every column to be grouped
            enableRowGroup: false
        };

        if(useFlex) {
            baseConfig.flex = 1;
        }



        if (customDefaultColDef) {
            return {
                //...baseConfig,
                ...customDefaultColDef
            };
        } else {
            return baseConfig;
        }
    }, [customDefaultColDef])

    const sidebar = useMemo(() => {
        return {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        enableRowGroup: false,
                        suppressPivotMode: true,
                        suppressValues: true,
                        suppressRowGroups: true
                    },
                }
            ],
            defaultToolPanel: '',
        }
    }, [])


    const localTexSpanish = useMemo(() => {
        return {
            // for filter panel
            page: 'Página',
            more: 'Más',
            to: 'a',
            of: 'de',
            next: 'Siguiente',
            last: 'Último',
            first: 'Primero',
            previous: 'Anterior',
            loadingOoo: 'Cargando...',
            
            // for set filter
            selectAll: 'Seleccionar Todo',
            searchOoo: 'Buscar...',
            blanks: 'En blanco',
    
            // for number filter and text filter
            filterOoo: 'Filtrar',
            applyFilter: 'Aplicar Filtro...',
            equals: 'Igual',
            notEqual: 'No Igual',
    
            // for number filter
            lessThan: 'Menos que',
            greaterThan: 'Mayor que',
            lessThanOrEqual: 'Menos o igual que',
            greaterThanOrEqual: 'Mayor o igual que',
            inRange: 'En rango de',
    
            // for text filter
            contains: 'Contiene',
            notContains: 'No contiene',
            startsWith: 'Empieza con',
            endsWith: 'Termina con',
    
            // filter conditions
            andCondition: 'Y',
            orCondition: 'O',
    
            // the header of the default group column
            group: 'Grupo',
    
            // tool panel
            columns: 'Columnas',
            filters: 'Filtros',
            valueColumns: 'Valor de las Columnas',
            pivotMode: 'Modo Pivote',
            groups: 'Grupos',
            values: 'Valores',
            pivots: 'Pivotes',
            toolPanelButton: 'BotonDelPanelDeHerramientas',
    
            // other
            noRowsToShow: 'No hay filas para mostrar',
    
            // enterprise menu
            pinColumn: 'Columna Pin',
            valueAggregation: 'Agregar valor',
            autosizeThiscolumn: 'Autoajustar esta columna',
            autosizeAllColumns: 'Ajustar todas las columnas',
            groupBy: 'agrupar',
            ungroupBy: 'desagrupar',
            resetColumns: 'Reiniciar Columnas',
            expandAll: 'Expandir todo',
            collapseAll: 'Colapsar todo',
            toolPanel: 'Panel de Herramientas',
            export: 'Exportar',
            csvExport: 'Exportar a CSV',
            excelExport: 'Exportar a Excel (.xlsx)',
            excelXmlExport: 'Exportar a Excel (.xml)',
    
    
            // enterprise menu pinning
            pinLeft: 'Pin Izquierdo',
            pinRight: 'Pin Derecho',
    
    
            // enterprise menu aggregation and status bar
            sum: 'Suman',
            min: 'Mínimo',
            max: 'Máximo',
            none: 'nada',
            count: 'contar',
            average: 'promedio',
    
            // standard menu
            copy: 'Copiar',
            copyWithHeaders: 'Copiar con cabeceras',
            paste: 'Pegar'   
        }
    },[]);

    const handleSelectionChanged = useCallback(() => {
        onSelectionChanged(gridRef.current.api.getSelectedRows());
    }, [onSelectionChanged]);

    const handleRowSelected = useCallback((event) => {
        onRowSelected(event);
    }, [onRowSelected]);

    const handleIsRowSelectable = useMemo(() => {
        return (rowNode) => {
            return isRowSelectable && isRowSelectable(rowNode);
        }
    }, [isRowSelectable]);

    if (isLoading) return (<Loading />)
    // if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <div className="row mb-3">
                <div className="col-sm-6 col-lg-6">
                    {
                        !hideFilter &&
                        <FilterAgGrid onFilterTextBoxChanged={onFilterTextBoxChanged} />
                    }
                </div>
                <div className="col-sm-6 col-lg-6 d-flex flex-row align-items-center justify-content-end" >
                    {addButton &&
                        addButton()
                    }
                    {isDownload &&
                        <div className="d-flex justify-content-end">
                            <button className="btn bg-light-blue btn-sm" onClick={onBtnExport}>
                                <span className="text-blue fw-bold ">
                                    <i className="fs-7 fi-rr-download text-blue fw-bold "></i> Descargar
                                </span>
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="table-responsive" style={{ display: hidden ? 'none' : '' }}>
                <div id="myGrid" className="ag-theme-balham" style={{ width: '100%' }} >
                    {(tableData) ?
                        <AgGridReact
                            ref={gridRef}
                            localeText={localTexSpanish}
                            rowData={tableData}
                            domLayout={'autoHeight'}
                            // groupIncludeFooter={groupIncludeFooter} groupIncludeTotalFooter={groupIncludeTotalFooter}
                            columnDefs={header}
                            defaultColDef={defaultColDef}
                            rowSelection={rowSelection}
                            // isRowSelectable={isRowSelectable}
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            rowDragManaged={rowDragManaged}
                            animateRows={animateRows}
                            sideBar={sidebar}
                            colResizeDefault={'shift'}
                            suppressSizeToFit={true}
                            //autoSizeAllColumns={true}
                            alwaysShowHorizontalScroll={true}
                            alwaysShowVerticalScroll={true}
                            // onColumnResized={onColumnResized}
                            // getRowHeight={getRowHeight}
                            cacheBlockSize={30}
                            rowHeight={rowHeight}
                            groupIncludeTotalFooter={sumColumns}
                            suppressRowClickSelection={suppressRowClickSelection}
                            onSelectionChanged={handleSelectionChanged}
                            onRowSelected={handleRowSelected}
                            isRowSelectable={handleIsRowSelectable}
                            rowGroupPanelShow={rowGroupPanelShow}
                        />
                        :
                        <p>No hay datos registrados.</p>}
                </div>
            </div>
        </>
    )
}